import axios from 'axios';

// 同源部署,baseURL 为空即可(由 server.js 处理路由)
export const API = axios.create({
  baseURL: '',
  withCredentials: true,  // 发送 admin_token cookie
});

// 业务 Key 的 axios 实例(不发送 cookie,只发 Authorization 头)
export const API_USER = axios.create({
  baseURL: '',
  withCredentials: false,
});
